export enum ProSubscriptionPlan {
  monthly = 'mensual',
  yearly = 'anual',
}

export enum ProSubscriptionPlanDto {
  monthly = 'MonthlyProPlan',
  yearly = 'YearlyProPlan',
}

export const proSubscriptionPlanOptions = {
  price: {
    [ProSubscriptionPlan.monthly]: 399,
    [ProSubscriptionPlan.yearly]: 2999,
  },
  label: {
    [ProSubscriptionPlan.monthly]: 'Mensual',
    [ProSubscriptionPlan.yearly]: 'Anual',
  },
  time: {
    [ProSubscriptionPlan.monthly]: 'mes',
    [ProSubscriptionPlan.yearly]: 'año',
  },
}

export interface CaretakerDetailsInfoProDto {
  selectedPlan: string
  renewalDate: Date | string
  lastNumbersOfCard: string
  endDate: Date | string
  enabledDate: Date | string
  couponCode: string
  freeMonths: number
  cardError: boolean
}

export interface CaretakerDetailsInfoPro {
  selectedPlan: string
  renewalDate: Date | string
  lastNumbersOfCard: string
  endDate: Date | string
  enabledDate: Date | string
  couponCode: string
  freeMonths: number
  cardError: boolean
}

export interface InfoDiscountCoupon {
  freeMonths: number
}
export interface InfoDiscountCouponDto {
  freeMonths: number
}

export enum IntentType {
  pendingSetup = 'PendingSetup',
  latestInvoicePayment = 'LatestInvoicePayment',
}

export interface ProSubscriptionUpdatePaymentMethodDto {
  newPaymentMethodId: string
}



// WEBPACK FOOTER //
// ./src/domain/model/pro/pro.model.ts